import React, {useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Select from 'react-select'
import {
  InfoDemandeImmatSelected,
  ModeleClientDemandePiece,
  ModeleEditCentre,
} from '../../../components/Models'

type TransfertCentreHnModalProps = {
  centres?: ModeleEditCentre[]
  onTransfertHn?: (ModeleEditCentre) => void
  infoSelected?: InfoDemandeImmatSelected
  pieceCentreAssign?: ModeleClientDemandePiece
  setPieceCentreAssign?: any
  selectedOptionHn?: any
  setSelectedOptionHn?: any
}

const TransfertCentreHnModal = (props: TransfertCentreHnModalProps) => {
  const {
    centres,
    infoSelected,
    onTransfertHn,
    pieceCentreAssign,
    setPieceCentreAssign,
    selectedOptionHn,
    setSelectedOptionHn,
  } = props

  const [pieceUp, setPieceUp] = useState<any>()

  const centreChange = (e) => {
    setSelectedOptionHn(e)
    const pieceUpdate = {
      ...pieceCentreAssign,
      centre: {
        nom: e.label,
        id: e.value,
      },
    }
    setPieceUp(pieceUpdate)
  }

  const transfert = () => {
    if (!infoSelected?.idDemande) {
      setPieceCentreAssign(pieceUp)
      onTransfertHn?.(pieceUp)
    }
  }

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_transfert_hn'>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Transfert de centre</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <Select
              className='react-select-styled react-select-solid react-select-lg'
              classNamePrefix='react-select'
              options={centres}
              fieldName='u_centre'
              value={selectedOptionHn}
              onChange={(e) => centreChange(e)}
              placeholder='Sélectionner centres'
            />
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
              Fermer
            </button>
            <button
              type='button'
              className='btn btn-primary'
              data-bs-dismiss='modal'
              onClick={transfert}
            >
              Transférer
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export {TransfertCentreHnModal}
